import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Brands from "@/pages/Brands";
import Approach from "@/pages/Approach";
import Partner from "@/pages/Partner";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  useEffect(() => {
    document.documentElement.lang = "en-IN";
  }, []);
  return (
    <BrowserRouter>
      <SmoothScroll>
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-2" data-testid="skip-to-content">
          Skip to content
        </a>
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/business-approach" element={<Approach />} />
            <Route path="/partner-with-us" element={<Partner />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-of-use" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
